<template>
  <div class="h-100 d-flex align-center justify-md-space-between justify-center">
    <!-- 👉 Footer: left content -->
    <span class="d-flex align-center text-medium-emphasis">
      &copy;
      {{ new Date().getFullYear() }}
      STARVLY
    </span>
    <!-- 👉 Footer: right content -->
    <span class="d-md-flex gap-x-4 text-primary d-none">
      <a
        href="/about"
        target="noopener noreferrer"
      >About</a>
      <a
        href="/contact"
        target="noopener noreferrer"
      >Contact</a>
      <a
        href="/privacy"
        target="noopener noreferrer"
      >Privacy</a>
      <a
        href="/terms"
        target="noopener noreferrer"
      >Terms</a>
    </span>
  </div>
</template>
